export default __webpack_public_path__ + "static/1493-60e45426a6e954562eaa5bdadadc252d.jpg";